import { Project, User, Company, Update } from 'api/models';

export function isProjectManager(project: Project, user: { _id?: string }): boolean {
  if (!project || !project.pmIds) {
    return false;
  }
  return project.pmIds.indexOf(user._id) >= 0;
}

export function isProjectUpdater(project: Project, user: { _id?: string }): boolean {
  if (!project || !project.updaterIds) {
    return false;
  }
  return project.updaterIds.indexOf(user._id) >= 0;
}

export function isCompanyAdmin(company: Company, user: { _id?: string }): boolean {
  if (!company || !company.adminIds || !user) {
    return false;
  }
  return company.adminIds.indexOf(user._id) >= 0;
}

export function isSuperAdmin(user: User): boolean {
  return user && user.isSuperAdmin;
}

export function userCanViewTotalFloat(userId: string, project: Project, update: Update) {
  return update && update.totalFloatPermissionMap && update.totalFloatPermissionMap[userId] || isProjectManager(project, {_id: userId});
}



// WEBPACK FOOTER //
// ./src/services/permissions.ts